export default __webpack_public_path__ + "static/media/tik-tok-icon.c5abab17.svg";